import cityList from '../../util/city'
import $DB from '../../util/debounce'
import QRCode from 'qrcodejs2'

// 个人信息
import Personal from './components/Personal.vue'
// 工作状况
import Worker from './components/Worker.vue'
// 学历信息
import Education from './components/Education.vue'
// 固定资产
import Property from './components/Property.vue'
// 其他
import Other from './components/Other.vue'
// 兴趣爱好
import Hobby from './components/Hobby.vue'
// 择偶标准
import Standard from './components/Standard.vue'
// 上传照片
import UploadPicture from './components/UploadPicture.vue'

export default {
  name: 'ApplyInitiation',
  components: {
    QRCode,

    Personal,
    Worker,
    Education,
    Property,
    Other,
    Hobby,
    Standard,
    UploadPicture,
  },
  data() {
    return {
      userInfo: {}, //个人信息
      options: [],

      gradeList: [], //会员等级列表

      vipMessage: {
        gr_mobile: '',
        code: '',
        gr_member_level: '',
      },
      i: null, //选择会员等级
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
      time: null, //时间
      isPay: false,
      isOrder: false,
      url: null,

      // 协议内容 serviceInfo.desc1=会员服务条款, serviceInfo.desc2=会员隐私保护政策
      serviceInfo: {},
      agreementInfo: {
        agreed: false, // 是否已同意协议
        show: false, // 协议弹框是否显示
        title: '',
        content: '',
      },
    }
  },
  created() {
    this.getUserInfo()
    this.getGradeList()
    this.funLoadAgreement()

    cityList.map((item) => {
      item.value = item.name
      item.label = item.name
      if (item.childs.length != 0) {
        item.children = item.childs
        item.children.map((item) => {
          item.value = item.name
          item.label = item.name
        })
      }
    })
    this.cityList = cityList
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          res.data.data.list = []
          let data = []
          if (res.data.data.m_desc) {
            data = res.data.data.m_desc.split('；')
            data.pop()
            data.map((item) => {
              res.data.data.list.push(item)
            })
          }
          this.userInfo = res.data.data
        }
      })
    },

    // 取消
    changeIsPay() {
      this.isPay = false
    },
    getPayState() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          res.data.data.list = []
          let data = []
          if (res.data.data.m_desc) {
            data = res.data.data.m_desc.split('；')
            data.pop()
            data.map((item) => {
              res.data.data.list.push(item)
            })
          }
          this.userInfo = res.data.data
          if (res.data.data.rec_status == 1) {
            clearInterval(this.time)
            this.$message({
              message: '支付成功',
              type: 'success',
            })
          }
        }
      })
    },
    // 去支付
    goPay: $DB(function () {
      if (this.isPay) return
      if (this.isOrder) {
        this.isPay = true
        setTimeout(() => {
          // eslint-disable-next-line no-unused-vars
          let qrcode = new QRCode('qrcode', {
            width: 124,
            height: 124, // 高度
            text: this.url, // 二维码内容
            // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            // background: '#f0f',   // 背景色
            // foreground: '#ff0'    // 前景色
          })
        }, 100)
        return
      }
      this.$axios
        .post('/api/refund/memberBuy', {
          member_id: this.userInfo.member_id,
          type: 2,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.url = res.data.data.pay_url
            this.isPay = true
            this.isOrder = true
            setTimeout(() => {
              // eslint-disable-next-line no-unused-vars
              let qrcode = new QRCode('qrcode', {
                width: 124,
                height: 124, // 高度
                text: res.data.data.pay_url, // 二维码内容
                // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f',   // 背景色
                // foreground: '#ff0'    // 前景色
              })
            }, 100)
            this.time = setInterval(() => {
              this.getPayState()
            }, 3000)
          }
        })
    }),

    // 获取手机短信验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.vipMessage.gr_mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.vipMessage.gr_mobile,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = this.second + 'S'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },

    //获取会员等级列表
    getGradeList() {
      this.$axios.post('/api/index/memberList').then((res) => {
        if (res.data.code === 0) {
          this.gradeList = res.data.data.memberList
        }
      })
    },
    // 点击等级中查看权益介绍
    goEquity() {
      this.$router.push('/equity')
    },
    // 选择会员等级
    handleSelectGrade(index) {
      this.i = index
      this.vipMessage.gr_member_level = this.gradeList[index].id
    },

    // 加载协议
    funLoadAgreement() {
      this.$axios.post('/api/index/service').then((res) => {
        if (res.data.code === 0) {
          this.serviceInfo = res.data.data
        }
      })
    },
    // 协议弹框同意
    handleAgreementPopupAgree() {
      this.agreementInfo.show = false
      this.agreementInfo.agreed = true
    },
    // 协议弹框取消
    handleAgreementPopupCancel() {
      this.agreementInfo.show = false
    },
    // 打开协议弹框
    handleOpenAgreementPopup(agreementName) {
      if (agreementName === '会员服务条款') {
        this.agreementInfo.title = '会员服务条款'
        this.agreementInfo.content = this.serviceInfo.desc1
      } else if (agreementName === '会员隐私保护政策') {
        this.agreementInfo.title = '会员隐私保护政策'
        this.agreementInfo.content = this.serviceInfo.desc2
      }
      this.agreementInfo.show = true
    },

    // 提交vip
    submitVip: $DB(function () {
      if (!this.vipMessage.gr_mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.vipMessage.code) {
        this.$message.error('请输入验证码')
        return
      }

      if (!this.agreementInfo.agreed) {
        this.$message.error('请勾选入会协议')
        return
      }
      if (this.userInfo.check_status == 1 || this.userInfo.check_status == 4) {
        if (!this.vipMessage.gr_member_level) {
          this.$message.error('请选择会员等级')
          return
        }
        this.$axios.post('/api/member/memberSub', this.vipMessage).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
            this.getUserInfo()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$axios.post('/api/member/memberEdit').then((res) => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
            this.getUserInfo()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    }),
  },
}
